import { createFileRoute, notFound } from "@tanstack/react-router";
import { getInsight, insightSlugs } from "@/lib/insights";
import { InsightShell } from "@/components/insights/InsightShell";
import { OG_IMAGE, absolute, hreflangLinks } from "@/lib/site";
import { graph, articleSchema, faqPage, breadcrumbList } from "@/lib/schema";

export const Route = createFileRoute("/ar/insights/$slug")({
  beforeLoad: ({ params }) => {
    if (!insightSlugs.includes(params.slug)) throw notFound();
  },
  head: ({ params }) => {
    const entry = getInsight(params.slug);
    if (!entry || !insightSlugs.includes(params.slug)) return {};
    const m = entry.meta;
    const url = absolute(`/ar/insights/${m.slug}`);
    return {
      meta: [
        { title: m.metaTitle.ar },
        { name: "description", content: m.description.ar },
        { property: "og:title", content: m.metaTitle.ar },
        { property: "og:description", content: m.description.ar },
        { property: "og:type", content: "article" },
        { property: "og:url", content: url },
        { property: "og:image", content: m.image ? absolute(m.image.src) : OG_IMAGE },
        { property: "og:locale", content: "ar_IQ" },
        { name: "twitter:image", content: m.image ? absolute(m.image.src) : OG_IMAGE },
      ],
      links: [{ rel: "canonical", href: url }, ...hreflangLinks(`/insights/${m.slug}`)],
      scripts: [
        {
          type: "application/ld+json",
          children: JSON.stringify(
            graph(
              articleSchema({
                path: `/ar/insights/${m.slug}`,
                headline: m.title.ar,
                description: m.description.ar,
                datePublished: m.datePublished,
                dateModified: m.dateModified,
                image: m.image ? absolute(m.image.src) : undefined,
                inLanguage: "ar",
              }),
              faqPage(
                `/ar/insights/${m.slug}`,
                m.faq.map((f) => ({ q: f.q.ar, a: f.a.ar })),
              ),
              breadcrumbList([
                { name: "الرئيسية", path: "/ar" },
                { name: "مقالات ودلائل", path: "/ar/insights" },
                { name: m.title.ar, path: `/ar/insights/${m.slug}` },
              ]),
            ),
          ),
        },
      ],
    };
  },
  component: InsightPageAr,
});

function InsightPageAr() {
  const { slug } = Route.useParams();
  const entry = getInsight(slug);

  if (!entry || !insightSlugs.includes(slug)) throw notFound();

  const { Body } = entry;
  return (
    <InsightShell meta={entry.meta}>
      <Body />
    </InsightShell>
  );
}
